<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import qs from 'qs'
import Cookie from 'js-cookie'
import { apiGet } from '@/services'
export default {
  name: 'app',
  watch: {
    '$route.path': {
      handler(path) {
        this.$nextTick(() => {
          apiGet('partner/open/wechat/getAppInfo', {url: window.location.href.split('#')[0]}).then(res => {
            if (res.code === '0000') {
              const {appId, nonceStr, signature, timestamp} = res.data
              if (!window.wx.config) return
              window.wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId, // 必填，公众号的唯一标识
                timestamp, // 必填，生成签名的时间戳
                nonceStr, // 必填，生成签名的随机串
                signature, // 必填，签名
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
              })
            }
          })
        })
      },
      immediate: true
    }
  },
  mounted () {
    // 接受保存返回的token
    let token = ''
    token = qs.parse(location.search.slice(1)).token || ''
    if (token) {
      Cookie.set('helper_tk', token, { expires: 7 })
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Outfit', 'SourceHanSansSC',-apple-system,'Segoe UI',sans-serif,"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
</style>
